import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import SEOHead from '@/components/feature/SEOHead';
import { articles } from '@/mocks/articles';

export default function Articles() {
  const schemaData = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    'name': '最新资讯 - 银河娱乐官方平台',
    'description': '银河娱乐最新资讯中心，为您提供新手指南、会员权益、安全保障、优惠活动与游戏推荐等专业内容，助您畅享顶级娱乐体验。',
    'url': 'https://51xlzxs.cn/articles',
    'breadcrumb': {
      '@type': 'BreadcrumbList',
      'itemListElement': [
        { '@type': 'ListItem', 'position': 1, 'name': '首页', 'item': 'https://51xlzxs.cn/' },
        { '@type': 'ListItem', 'position': 2, 'name': '最新资讯', 'item': 'https://51xlzxs.cn/articles' },
      ],
    },
  };

  return (
    <>
      <SEOHead
        title="最新资讯 - 银河娱乐官方平台"
        description="银河娱乐最新资讯中心，为您提供新手指南、会员权益、安全保障、优惠活动与游戏推荐等专业内容，助您畅享顶级娱乐体验。"
        keywords="银河娱乐资讯,银河娱乐攻略,银河娱乐优惠,银河娱乐安全,游戏推荐"
        canonicalUrl="https://51xlzxs.cn/articles"
        schemaData={schemaData}
      />

      <Navbar />

      <main className="pt-20">
        <div className="bg-background-100">
          <div className="max-w-7xl mx-auto pt-8 pb-4">
            <Breadcrumb />
            <div className="px-4 md:px-6 pb-8">
              <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">最新资讯</h1>
              <p className="text-foreground-600 mt-3 text-base">掌握银河娱乐最新动态、攻略指南与优惠信息</p>
            </div>
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 md:px-6 py-10">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {articles.map((article) => (
              <Link
                key={article.id}
                to={`/articles/${article.slug}`}
                className="group rounded-xl overflow-hidden bg-background-100 hover:bg-background-200/80 transition-all duration-300 cursor-pointer"
              >
                <div className="h-52 overflow-hidden">
                  <img
                    src={article.coverImage}
                    alt={article.title}
                    className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                  />
                </div>
                <div className="p-5">
                  <div className="flex items-center gap-3 mb-3 flex-wrap">
                    <span className="px-2.5 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium">{article.category}</span>
                    <span className="text-xs text-foreground-500">{article.date}</span>
                    <span className="text-xs text-foreground-500 flex items-center gap-1">
                      <i className="ri-time-line w-3 h-3 flex items-center justify-center"></i>
                      {article.readTime}
                    </span>
                  </div>
                  <h2 className="font-heading text-lg font-semibold text-foreground-950 mb-3 line-clamp-2 group-hover:text-primary-600 transition-colors">
                    {article.title}
                  </h2>
                  <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">{article.excerpt}</p>
                  <div className="flex items-center gap-2 mt-4 flex-wrap">
                    {article.tags.map((tag) => (
                      <span key={tag} className="px-2 py-0.5 rounded-md bg-background-200/60 text-xs text-foreground-500">
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
              </Link>
            ))}
          </div>

          {/* Pagination */}
          <nav className="flex items-center justify-center gap-2 mt-12" aria-label="分页导航">
            <button className="w-10 h-10 flex items-center justify-center rounded-lg border border-background-200 text-foreground-400 cursor-not-allowed opacity-50" disabled>
              <i className="ri-arrow-left-s-line text-lg"></i>
            </button>
            <button className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 text-sm font-semibold">1</button>
            <button className="w-10 h-10 flex items-center justify-center rounded-lg border border-background-200 text-foreground-600 text-sm hover:border-primary-300 hover:text-primary-500 transition-colors cursor-pointer">2</button>
            <button className="w-10 h-10 flex items-center justify-center rounded-lg border border-background-200 text-foreground-600 text-sm hover:border-primary-300 hover:text-primary-500 transition-colors cursor-pointer">3</button>
            <button className="w-10 h-10 flex items-center justify-center rounded-lg border border-background-200 text-foreground-600 hover:border-primary-300 hover:text-primary-500 transition-colors cursor-pointer">
              <i className="ri-arrow-right-s-line text-lg"></i>
            </button>
          </nav>
        </div>
      </main>

      <Footer />
    </>
  );
}